import styled, { css } from "styled-components";
import { DhlText } from "@dhl-official/react-library";
import { breakpoints } from "root/libs/ui-styleguide/src";
import WeightSelector from "one-time-shipment/src/components/ShipmentItem/WeightSelector";
import {
  Headline,
  Icon,
  IconButton,
  Form,
  GridContainer,
  biDimemsionalCell,
} from "root/libs/ui-components/src";

import bgImageS from "iconsMultiColor/cx/shipment-lane-bg-S.webp";

const ieCheckboxButtonPadding = "60%";
const dimensionsContentPaddingLeftRightTablet = "38px";
const dimensionsContentPaddingLeftRightDesktop = "25px";
const dimensionsContentGridGap = "20px";
const dimensionsContentMarginTopTotalShipmentWeight = "20px";

export const ShipmentLaneFormWrapper = styled(Form)`
  padding-top: var(--dui-size-space-10x);
  padding-bottom: var(--dui-size-space-10x);
  ${(props) =>
    props.stepperEnabled
      ? `
        background-color: #f9f9f9;
      `
      : `
        background-color: var(--dui-color-yellow-500);
        background-image: url(${bgImageS}),
          linear-gradient(135deg, var(--dui-color-yellow-500) 9%, #fff1b4 100%);
        background-size: cover;
      `}
  background-size: cover;
  position: relative;

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding-top: var(--gaq-size-space-45px);
    padding-bottom: var(--gaq-size-space-50px);
    ${(props) =>
      !props.stepperEnabled &&
      `
          background-image: url(${bgImageS}),
            linear-gradient(135deg, var(--dui-color-yellow-500) 9%, #fff1b4 100%);
        `}
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    ${(props) =>
      props.stepperEnabled
        ? "padding-top: var(--dui-size-space-24x);"
        : "padding-top: var(--dui-size-space-32x);"}
    padding-bottom: var(--dui-size-space-10x);
  }

  .button-wrapper {
    margin-left: var(--dui-size-space-10x);
    margin-right: var(--dui-size-space-10x);

    @media screen and (min-width: ${breakpoints.tablet}) {
      margin-left: 0;
      margin-right: 0;
    }
  }

  @media print {
    padding: 0px;

    & > h2 {
      margin: 0px;
    }
  }
`;

export const StyledIconWrapper = styled.div`
  display: inline-block;
  margin: 0 var(--dui-size-space-5x) 0 0;

  svg {
    color: var(--dui-color-red-500);
    width: 52px;
    height: 52px;
  }
`;

export const CustomBackButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: var(--gaq-size-space-130px);
  background-color: var(--dui-colors-action-background-secondary-default);
  color: var(--dui-colors-action-foreground-secondary-default);
  border: var(--dui-size-space-1) solid
    var(--dui-colors-action-foreground-secondary-default);
  padding: var(--dui-size-space-7x) var(--dui-size-space-8x);
  font-size: var(--dui-size-font-md);
  border-radius: var(--dui-size-space-2x);
  cursor: pointer;
  transition: background 0.2s ease;
  font-weight: var(--dui-font-weight-bold);

  &:focus-visible {
    outline: var(--dui-size-space-1x) solid
      var(--dui-colors-action-background-primary-default);
    outline-offset: var(--dui-size-space-1x);
    z-index: 1;
  }

  &:hover {
    border-color: var(--dui-colors-action-foreground-secondary-hover);
    color: var(--dui-colors-action-foreground-secondary-hover);
    svg {
      color: var(--dui-colors-action-foreground-secondary-hover);
    }
  }

  svg {
    width: var(--dui-size-space-8x);
    height: var(--dui-size-space-8x);
    color: var(--dui-colors-action-foreground-secondary-default);
    transition: color 0.2s ease;
  }
`;

export const StyledHeadline = styled(Headline)`
  margin-right: var(--dui-size-space-10x);
  margin-left: var(--dui-size-space-10x);
  margin-bottom: var(--gaq-size-space-30px) !important;

  ${(props) =>
    props.stepperEnabled &&
    `
      @media screen and (min-width: ${breakpoints.tablet}) {
        margin-left: var(--gaq-size-space-30px) !important;
      }
    `}

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-bottom: 0 0 var(--gaq-size-space-30px) 0;
  }
`;

export const ieShipmentItemGridContainer = css`
  /* Only for IE11 */
  @media all and (-ms-high-contrast: none) {
    max-width: 100rem;
  }

  /* Only for EDGE */
  /* stylelint-disable selector-type-no-unknown */
  _:-ms-lang(x),
  _:-webkit-full-screen,
  & {
    max-width: 100rem;
  }
  /* stylelint-enable selector-type-no-unknown */
`;

export const ShipmentItemGridContainer = styled(GridContainer)`
  margin-top: var(--dui-size-space-10x);

  @supports (display: grid) {
    grid-row-gap: 0;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    grid-template-columns: repeat(12, 1fr);
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    // Adjust column width based on stepperEnabled: 68px for stepper, 73px for default
    ${(props) =>
      props.stepperEnabled
        ? "grid-template-columns: repeat(12, 68px);"
        : "grid-template-columns: repeat(12, 73px);"}
  }

  ${ieShipmentItemGridContainer}
`;

export const ieSubmitButtonCell = css`
  /* Only for IE11 */
  @media all and (-ms-high-contrast: none) {
    padding-left: ${ieCheckboxButtonPadding};
  }

  /* Only for EDGE */
  /* stylelint-disable selector-type-no-unknown */
  _:-ms-lang(x),
  _:-webkit-full-screen,
  & {
    padding-left: ${ieCheckboxButtonPadding};

    @supports (display: grid) {
      padding-left: 0;
    }
  }
  /* stylelint-enable selector-type-no-unknown */
`;

export const SubmitButtonCell = styled.div`
  ${biDimemsionalCell}
  margin-top: ${dimensionsContentGridGap};

  & > dhl-button > .styled:is(button,a) {
    display: block;
    line-height: 21px !important;
    padding: var(--dui-size-space-5x) var(--gaq-size-space-30px) var(--gaq-size-space-11px) !important;
    font-size: 1.5rem !important;
    min-height: auto;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    align-self: center;

    & > dhl-button,
    & > dhl-button > .styled:is(button,a) {
      width: 100% !important;
    }

    @supports (display: grid) {
      grid-column: 7 / span 6;
    }
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    padding-left: 40px;

    @supports (display: grid) {
      ${({ stepperEnabled }) =>
        stepperEnabled
          ? `grid-column: 1 / span 11;`
          : `grid-column: 8 / span 4;`}
    }
  }

  @media print {
    display: none;
  }

  ${ieSubmitButtonCell}
`;

export const ieAddItemButtonCell = css`
  /* Only for IE11 */
  @media all and (-ms-high-contrast: none) {
    padding-right: 50%;
    height: 0;
    margin-top: var(--gaq-size-space-30px);
    margin-bottom: var(--gaq-size-space--30px);
  }

  /* Only for EDGE */
  /* stylelint-disable selector-type-no-unknown */
  _:-ms-lang(x),
  _:-webkit-full-screen,
  & {
    padding-right: 50%;
    height: 0;
    margin-top: var(--gaq-size-space-30px);
    margin-bottom: var(--gaq-size-space--30px);

    @supports (display: grid) {
      padding-left: 0;
      margin-top: 0;
      margin-bottom: 0;
      padding-right: 0;
      height: auto;
      width: 100%;

      @media screen and (min-width: ${breakpoints.tablet}) {
        width: 500px;
      }
    }
  }
  /* stylelint-enable selector-type-no-unknown */
`;

export const AddItemButtonCell = styled.div`
  ${biDimemsionalCell}

  @media screen and (min-width: ${breakpoints.tablet}) {
    align-self: start;

    @supports (display: grid) {
      grid-column: 1;
      width: fit-content;
      grid-row-end: span 3;
    }
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    @supports (display: grid) {
      grid-column: 2;
    }
  }

  @media print {
    & > button {
      display: none;
    }
  }

  ${ieAddItemButtonCell}
`;

export const StepNoteCell = styled.div`
  @media screen and (max-width: ${breakpoints.tablet}) {
    @supports (display: grid) {
      grid-column: 12;
      white-space: nowrap;
      font-size: var(--dui-size-font-sm);
      font-weight: var(--dui-font-weight-bold);
      margin-top: var(--dui-size-space-8x);
    }
  }
`;

export const BackButtonCell = styled.div`
  ${biDimemsionalCell}
  margin-top: var(--dui-size-space-10x);
  @media screen and (max-width: ${breakpoints.tablet}) {
    order: 2;
  }
  @media screen and (min-width: ${breakpoints.tablet}) {
    align-self: start;
    order: unset;
    @supports (display: grid) {
      grid-column: 1;
      width: fit-content;
      grid-row-end: span 3;
    }
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    @supports (display: grid) {
      grid-column: 2;
    }
  }

  @media print {
    & > button {
      display: none;
    }
  }

  ${ieAddItemButtonCell}
`;

export const ieStyledIconButton = css`
  /* Only for IE11 */
  @media all and (-ms-high-contrast: none) {
    width: auto;
  }

  /* Only for EDGE */
  /* stylelint-disable selector-type-no-unknown */
  _:-ms-lang(x),
  _:-webkit-full-screen,
  & {
    width: 100%;

    @media screen and (min-width: ${breakpoints.tablet}) {
      width: auto;
    }
  }
  /* stylelint-enable selector-type-no-unknown */
`;

export const StyledIconButton = styled(IconButton)`
  line-height: 1em;
  width: 100%;
  margin-top: var(--dui-size-space-5x);

  svg {
    margin-right: var(--dui-size-space-5x);
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-top: var(--dui-size-space-10x);
    padding-left: var(--gaq-size-space-52px);
    padding-right: var(--dui-size-space-10x);
    width: max-content;

    &:active,
    &:focus {
      padding-left: var(--gaq-size-space-51px);
      padding-right: var(--dui-size-space-10x);
    }

    svg {
      margin-right: 0;
      position: absolute;
      left: 25px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    margin-top: 0;
  }

  ${ieStyledIconButton}
`;

export const DimensionsContent = styled(GridContainer)`
  position: relative;
  transition: padding-top 0.3s ease-out;
  ${(props) =>
    props.isItemIndexVisible
      ? "padding-top: var(--gaq-size-space-29px);"
      : "padding-top: var(--gaq-size-space-5px);"}
  padding-bottom: var(--gaq-size-space-5px);
  background-color: var(--dui-color-white-500);
  border-radius: var(--dui-size-radius-md);
  border-radius: ${(props) =>
    props.stepperEnabled
      ? "var(--dui-size-radius-lg)"
      : "var(--dui-size-radius-md)"};
  ${biDimemsionalCell}
  margin-bottom: ${dimensionsContentGridGap};
  ${(props) =>
    props.stepperEnabled && `box-shadow: rgba(0, 0, 0, 0.10) 0px 5px 15px;`}
  &.added-item {
    overflow: hidden;
    opacity: 0;
    animation: new-item 0.4s ease-in-out forwards;
    margin-top: var(--gaq-size-space-30px);
  }

  &.deleted-item {
    overflow: hidden;
    height: auto;
    animation:
      remove-item-hide 0.3s ease-in-out forwards,
      remove-item-shrink 0.3s 0.3s ease-in-out forwards;
  }

  @keyframes new-item {
    0% {
      opacity: 0;
      transform: translateY(-110%);
    }

    20% {
      opacity: 0.7;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes remove-item-hide {
    0% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  @keyframes remove-item-shrink {
    0% {
      height: auto;
      padding-top: var(--gaq-size-space-29px);
      padding-bottom: var(--gaq-size-space-5px);
      margin-top: var(--gaq-size-space-30px);
      margin-bottom: ${dimensionsContentGridGap};
    }

    100% {
      height: 0;
      padding-top: 0;
      padding-bottom: 0;
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding: 42px ${dimensionsContentPaddingLeftRightTablet} 20px;
    ${(props) =>
      props.isItemIndexVisible
        ? "padding-top: var(--gaq-size-space-56px);"
        : "padding-top: var(--dui-size-space-20x);"}
    align-items: flex-start;
  }

  @supports (display: grid) {
    grid-row-gap: 0;
    grid-template-rows: [weightRow] 1fr [dimensionsRow] auto; /* stylelint-disable-line value-keyword-case */

    @media screen and (min-width: ${breakpoints.tablet}) {
      grid-column-gap: 25px;
      grid-template-areas: ". weightCol weightCol weightCol weightCol . . . iconCol iconCol iconCol .";
      grid-template-rows: [weightRow] auto [dimensionsRow] auto [presetsRow] auto; /* stylelint-disable-line value-keyword-case */
      grid-template-columns: repeat(1, 1fr);
      padding-left: var(--gaq-size-space-15px);
      padding-right: var(--gaq-size-space-15px);
    }

    @media screen and (min-width: ${breakpoints.desktop}) {
      grid-template-rows: [dimensionsRow] 1fr [presetsRow] auto; /* stylelint-disable-line value-keyword-case */
      grid-template-areas: ${(props) =>
        props.isBusiness
          ? '". weightCol weightCol iconCol iconCol dimensionsCol dimensionsCol dimensionsCol dimensionsCol dimensionsCol quantityCol quantityCol"'
          : '". weightCol weightCol iconCol iconCol dimensionsCol dimensionsCol dimensionsCol dimensionsCol dimensionsCol dimensionsCol ."'};
        ${(props) =>
          props.isBusiness
            ? "grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 8fr 1fr;"
            : ""}
        ${(props) =>
          !props.isBusiness && props.stepperEnabled
            ? "grid-template-columns: repeat(12, 68px);"
            : ""}
    }
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    padding-left: ${dimensionsContentPaddingLeftRightDesktop};
    padding-right: ${dimensionsContentPaddingLeftRightDesktop};
  }

  @media print {
    display: flex;
    flex-direction: column;
  }
`;

export const StyledWeightSelector = styled(WeightSelector)`
  @media screen and (min-width: ${breakpoints.desktop}) {
    ${(props) => (props.isBusiness ? "grid-column-start: 1;" : "")}
  }
`;

export const ieSettingsCheckboxWrapper = css`
  /* Only for IE11 */
  @media all and (-ms-high-contrast: none) {
    padding-left: ${ieCheckboxButtonPadding};
    margin: var(--dui-size-space-10x) 0;
  }

  /* Only for EDGE */
  /* stylelint-disable selector-type-no-unknown */
  _:-ms-lang(x),
  _:-webkit-full-screen,
  & {
    padding-left: ${ieCheckboxButtonPadding};
    margin: var(--dui-size-space-10x) 0;

    @supports (display: grid) {
      padding-left: 0;
    }
  }
  /* stylelint-enable selector-type-no-unknown */
`;

export const SettingsCheckboxWrapper = styled.div`
  margin: 0;
  ${biDimemsionalCell}

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin: var(--dui-size-space-5x) 0 -12px;
    margin: var(--dui-size-space-5x) 0  var(--gaq-size-space--12px);

    @supports (display: grid) {
      grid-column: 7 / span 6;
    }
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    margin: -10px 0 -5px;
    padding-left: var(--dui-size-space-20x);

    @supports (display: grid) {
      grid-column: 8 / span 4;
    }
  }

  @media print {
    display: flex;
    flex-direction: row;
  }

  ${ieSettingsCheckboxWrapper}
`;

export const StyledCheckboxInfo = styled.div`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  margin: 0;
  justify-content: space-between;
  padding: var(--dui-size-space-5x) 0 0 0;
  position: relative;
  width: 100%;

  .iconWrapper {
    position: absolute;
    right: 0;
    top: 0;
  }

  label {
    height: auto !important;
    min-height: 20px !important;
  }

  input {
    /*! @noflip */
    left: -9999px;
    /*! @noflip */
    right: unset;
    position: absolute;
  }
`;

export const StyledItemIndexNumber = styled(DhlText)`
  position: absolute;
  top: 4px;
  left: 12px;

  & > *:is(p, span) {
    margin-top: var(--dui-size-space-5x);
    margin-bottom: var(--dui-size-space-5x);
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    top: 9px;
    left: 10px;
    left: ${dimensionsContentPaddingLeftRightTablet};
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    left: ${dimensionsContentPaddingLeftRightDesktop};
  }
`;

export const StyledCloseIcon = styled(Icon)`
  transition: opacity 0.3s ease-out;
  ${(props) => (props.itemAdded ? "opacity: 1;" : "opacity: 0;")}
  position: absolute;
  top: 5px;
  right: 5px;
  border: 1px solid transparent;

  @media screen and (min-width: ${breakpoints.tablet}) {
    top: 10px;
    right: 10px;
  }
`;

export const StyledHiddenCloseIconContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  overflow: hidden;
  width: 50px;
  height: 50px;
`;

export const StyledHiddenCloseIcon = styled(Icon)`
  opacity: 0;
  position: absolute;
  bottom: -60px;
  right: 5px;

  &:focus {
    opacity: 1;
    bottom: 5px;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    right: 10px;

    &:focus {
      bottom: 10px;
    }
  }
`;

export const StyledTotalShipmentWeightWrapper = styled.div`
  margin-top: ${(props) =>
    props.addItemButtonVisible
      ? dimensionsContentMarginTopTotalShipmentWeight
      : "10px"};
  margin-bottom: 0;

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-top: ${dimensionsContentMarginTopTotalShipmentWeight};
    margin-bottom: var(--dui-size-space-5x);
    white-space: nowrap;
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    margin-top: ${(props) =>
      props.addItemButtonVisible
        ? dimensionsContentMarginTopTotalShipmentWeight
        : 0};
  }
`;
export const ToolTipText = styled(DhlText)`
  & > *:is(p, span) {
    margin-bottom: ${(props) =>
      props.isParagraph ? "var(--dui-size-space-5x)" : 0} !important;
  }
`;
